<template>
  <div class="overflow-transition">
    <div class="overflow-text">
      <overflow-transition-character v-for="(c, i) in 100" :key="i" :index="i" :content="text[i] || ''" :text="text"/>
    </div>
  </div>
</template>

<script>

import OverflowTransitionCharacter from '@/components/OverflowTransitionCharacter.vue'

export default {
  name: 'OverflowTransition',
  components: {
    OverflowTransitionCharacter
  },
  props: {
    text: {
      type: String,
      required: true
    },
    lineHeight: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss">
.overflow-transition {
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--white);
  overflow: hidden;
  .overflow-text {
    display: flex;
    flex-direction: row;
  }
  .character {
    &.space {
      margin-left: 7px;
    }
  }

  .character-enter-active, .character-leave-active {
    transition: transform .5s var(--easing), opacity 4s var(--easing);
    will-change: transform;
  }
  .character-enter {
    transform: translateY(-52px);
  }
  .character-leave-to {
    transform: translateY(52px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OverflowTransition.vue